import React from 'react';
import PropTypes from 'prop-types';
import { isFinite } from 'lodash';

import WithShopCurrency from '../hoc/WithShopCurrency';
import config from '../../config';
import { formatPrice } from '../utils/helpers';

const Money = ({ children, noDecimalsIfInt, currency, cents }) => {
  const amount = isFinite(cents) ? cents : children;
  if (!isFinite(amount)) return null;
  return <span>{formatPrice(amount, currency, noDecimalsIfInt)}</span>;
};
Money.propTypes = {
  children: PropTypes.number,
  noDecimalsIfInt: PropTypes.bool,
  currency: PropTypes.string,
  cents: PropTypes.number,
};
Money.defaultProps = {
  noDecimalsIfInt: false,
  currency: config.defaultCurrency,
  cents: null,
  children: null,
};

export default WithShopCurrency(Money);



// WEBPACK FOOTER //
// ./src/app/components/Money.jsx